export const mockFeatureResponse = {
  data: [
    {
      client: 'tjx',
      features: {
        accessToGoogleWallet: true,
        accessToAppleWallet: true,
        accessToSamsungWallet: true,
        accessToVirtualCard: true,
        accessToSingleUseCard: true,
        accessToPlasticId: false,
        accessToTempShoppingPass: false,
        accessToTokenizedShoppingPass: false,
        accessToLanguageToggle: true,
        accessToCreditLimitIncrease: false,
        accessToUiBarcode: false,
      },
    },
    {
      client: 'verizon',
      features: {
        accessToGoogleWallet: false,
        accessToAppleWallet: true,
        accessToSamsungWallet: false,
        accessToVirtualCard: false,
        accessToSingleUseCard: true,
        accessToPlasticId: false,
        accessToTempShoppingPass: false,
        accessToTokenizedShoppingPass: false,
        accessToLanguageToggle: false,
        accessToCreditLimitIncrease: false,
        accessToUiBarcode: false,
      },
    },
    {
      client: 'chevron',
      features: {
        accessToGoogleWallet: false,
        accessToAppleWallet: true,
        accessToSamsungWallet: false,
        accessToVirtualCard: false,
        accessToSingleUseCard: true,
        accessToPlasticId: false,
        accessToTempShoppingPass: false,
        accessToTokenizedShoppingPass: false,
        accessToLanguageToggle: false,
        accessToCreditLimitIncrease: false,
        accessToUiBarcode: true,
      },
    },
    {
      client: 'athome',
      features: {
        accessToGoogleWallet: false,
        accessToAppleWallet: true,
        accessToSamsungWallet: false,
        accessToVirtualCard: false,
        accessToSingleUseCard: false,
        accessToPlasticId: false,
        accessToTempShoppingPass: false,
        accessToTokenizedShoppingPass: false,
        accessToLanguageToggle: false,
        accessToCreditLimitIncrease: false,
        accessToUiBarcode: false,
      },
    },
    {
      client: 'lowes',
      features: {
        accessToGoogleWallet: false,
        accessToAppleWallet: true,
        accessToSamsungWallet: false,
        accessToVirtualCard: false,
        accessToSingleUseCard: false,
        accessToPlasticId: false,
        accessToTempShoppingPass: false,
        accessToTokenizedShoppingPass: true,
        accessToLanguageToggle: true,
        accessToCreditLimitIncrease: true,
        accessToUiBarcode: true,
      },
    },
  ],
};
